import React from "react";
import {Pie as PieChart} from 'react-chartjs-2';
import {Card, CardBody, CardHeader, CardTitle} from "reactstrap";
import PieAssembler from "./PieAssembler";

const Pie = ({data: jsonData}) => {
    const pieAssembler = new PieAssembler();
    const data = pieAssembler.toChartJs(jsonData.data);
    const {title} = jsonData;

    return (
        <Card className="card-chart">
            <CardHeader>
                <CardTitle tag="h4">{title}</CardTitle>
            </CardHeader>
            <CardBody>
                <div>
                    <div className="chart-area">
                        <PieChart

                            data={data}
                            width={50}
                            height={50}
                            options={{maintainAspectRatio: false}}
                        />
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default Pie;